import useNotifications from '@anm/hooks/useNotifications';

import { DeleteFolderState } from '../../../../store/modules/videoFolder';

const errorMessage = "Couldn't delete a folder. Please try again later";

const useDeleteFolderNotifications = (entity: DeleteFolderState) => {
  const { notifications } = useNotifications({
    ...entity,
    errorMessage
  });

  return { deleteFolderNotifications: notifications };
};

export default useDeleteFolderNotifications;
